'use client';

import { useTranslation } from 'next-i18next';
import { PlusIcon } from '@heroicons/react/24/outline';
import { PopoverStyled, PopoverStyledButton, PopoverStyledPanel } from '@components/common/Popover/PopoverStyled';
import type { PromptBarMode } from './usePromptBarMode';
import { useMissionNavItems } from './useMissionNavItems';
import { PromptBarActionsList } from './PromptBarActionsList';

interface PromptBarActionsPopupProps {
  locale: Locale;
  /** Kept for call-site compatibility — the popup layout no longer varies by mode. */
  mode?: PromptBarMode;
  isAuthenticated: boolean;
}

export const PromptBarActionsPopup = ({ locale, isAuthenticated }: PromptBarActionsPopupProps) => {
  const { t } = useTranslation('common');
  // Mirrors the nav layout (Jobs / Coach / Talents) + MyJobs+ as a plain entry.
  const { items, handleClick } = useMissionNavItems(locale, isAuthenticated, true);

  return (
    <PopoverStyled className="relative">
      <PopoverStyledButton
        as="button"
        type="button"
        aria-label={t('global.label.menu', 'Menu')}
        className="group flex size-9 cursor-pointer items-center justify-center rounded-lg text-ink-medium transition-colors hover:bg-surface-100 hover:text-ink data-[open]:bg-surface-200 lg:size-10"
      >
        <PlusIcon className="size-5 transition-transform duration-500 group-data-[open]:rotate-45" />
      </PopoverStyledButton>

      <PopoverStyledPanel
        animation="slideUp"
        position="left"
        className="absolute bottom-full left-0 mb-2 min-w-[200px] max-w-[280px] rounded-xl border border-input bg-surface p-1 shadow-lg"
      >
        <PromptBarActionsList items={items} onItemClick={handleClick} />
      </PopoverStyledPanel>
    </PopoverStyled>
  );
};
